import { initOnlineChat } from './initOnlineChat';
import setAvailabilityStyles from './setAvailabilityStyles';
import { shouldLoadOnlineChat } from './shouldLoadOnlineChat';

(async () => {
  if (await shouldLoadOnlineChat()) {
    setAvailabilityStyles(true);
    await initOnlineChat();
  } else {
    setAvailabilityStyles(false);
  }
})();
